module.exports = __tmimport("~endpoint:{controller: \'customized/api\', action: \'check_drafts\', event_id: \':event_id\'}");